/**
 * Machine users that start AI Advisor chats on their own, rather than a person. Use these everywhere the Kentik AI UI
 * separates people's chats from automated ones, so lists, filters and usage stats all agree.
 */

const getEmail = (user) => (user?.user_email || '').toLowerCase();

/**
 * Kproxy agents are how sudo users try out a company's AI Advisor, so their chats are only shown to sudo users.
 */
export function isKProxyAgentUser(user) {
  return getEmail(user).startsWith('kproxy-agent');
}

export function isAutomatedUser(user) {
  const email = getEmail(user);
  return isKProxyAgentUser(user) || email.startsWith('kentik-ai+') || email === 'kentiscope@kentik.com';
}
